/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	console.log('hti ready')
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$( ".kt-blocks-post-footer" ).remove();
	

	$('.kt-blocks-accordion-header').each(function(index) {
		let faqNum = index + 1;
		$(this).before("<p class='faq-list-item'>" + faqNum + "</p>");
	})

	$('.kt-blocks-accordion-header').click(function() {
       
        // Update the color of <p> elements based on aria-expanded
        $('.kt-blocks-accordion-header').each(function() {
            let isExpanded = $(this).attr('aria-expanded') === 'true';
            if (isExpanded) {
                $(this).prev('.faq-list-item').addClass('faq-list-item-active');
            } else {
                $(this).prev('.faq-list-item').removeClass('faq-list-item-active');
            }
	});
    });

	$(".pdf-menu-link a").each(function() {
		$(this).attr('target', '_blank')
	});

	$('#maintenance-popup-btn').on('click', function(event) {
		event.preventDefault();
		$('#maintenance-popup').show();
		$('#popupOverlay').show();
	});

	$('.maintenance-popup a').on('click', function(event) {
		event.preventDefault();
		$('#maintenance-popup').show();
		$('#popupOverlay').show();
	});

	$('#popupOverlay').on('click', function() {
		$('#maintenance-popup').hide();
		$('#vacate-popup').hide();
		$('#popupOverlay').hide();
		$('#client-popup').hide();
	});

	$('#vacate-popup-btn').on('click', function(event) {
		event.preventDefault();
		$('#vacate-popup').show();
		$('#popupOverlay').show();
	});

	$('#client-popup-btn').on('click', function(event) {
		event.preventDefault();
		$('#client-popup').show();
		$('#popupOverlay').show();
	});

	$('#promotions-pdf .kt-testimonial-meta-wrap').wrap("<a href='http://northpointam.dev/wp-content/uploads/2024/05/Northpoint-Promotions-2018.pdf' aria-label='promotions pdf' target='_blank'></a>");

	$('#sell-your-property-pdf .kt-testimonial-meta-wrap').wrap("<a href='/wp-content/uploads/2024/05/Sell-Your-Home-DISCOUNT-Northpoint.pdf' aria-label='sell home pdf' target='_blank'></a>");

	$('#newsletter-pdf .kt-testimonial-meta-wrap').wrap("<a href='wp-content/uploads/2024/05/Placeholder-website.pdf' aria-label='newsletter pdf' target='_blank'></a>");

	addEventListener('click', (event) => { var buttons = document.getElementsByClassName("btn btn-primary btn-lg btn-block text-uppercase text-semibold"); console.log(buttons); var searchText = "Apply"; var found; for (var i = 0; i < buttons.length; i++) { console.log(i); if (buttons[i].textContent === searchText) { found = buttons[i]; break; } } const urlObj = new URL(found.baseURI); urlObj.search = ''; const cleanedUrl = urlObj.toString(); const idMatch = found.baseURI.match(/\/property\/(\d+)/)[1]; let propertyId = null; if (idMatch) { propertyId = idMatch; } const newUrl = `https://api.findigs.com/rental_applications/lookup/?unit_id=${propertyId}`; found.setAttribute('href', newUrl) })
}); 


